import { config, platConfig } from './global-config'
import { useInterceptors } from './network-config-with-app'
import { generateNet } from '../util/network-util'

export const net = generateNet(config, useInterceptors)
export const platNet = generateNet(platConfig, useInterceptors)

// 代理接口
export const API_POST_PROXY = '/url/proxy'
/**
 * 通用代理接口
 */
export function postProxy(appCode, params) {
    return net.post(API_POST_PROXY, {
        appCode,
        param: JSON.stringify(params),
    })
}

export const API_GET_USERINFO = 'api/user'
const API_GET_TENANT_LIST = 'eim-hr-plus/api/hr/plus/comm/tenant'

/**
 * 获取当前登陆用户信息
 */
export function getUserInfo(params) {
    return platNet.get(API_GET_USERINFO, { params })
}

/**
 * 获取当前用户可用租户
 */
export function getTenantList(params) {
    return platNet.get(API_GET_TENANT_LIST, { params })
}

// 部门查询接口
export const API_GET_OUTDEPTS =  '/api/depts'

export function getDeptList(params) {
    return platNet.get(API_GET_DEPTS, { params })
}

// 用户查询接口
export const API_GET_OUTUSERS =  '/api/users'

export function getUsers(params) {
    return net.get(API_GET_OUTUSERS, { params })
}

// 外部用工接口
export const API_GET_OUTJOB = '/eim-hr-outside/api/hr/outside/base/job-list'  // 查询职务列表接口
export const API_POST_CHECKID = '/eim-hr-outside/api/hr/outside/base/check-id'  // 身份验证接口
export const API_GET_PINYIN = '/eim-hr-outside/api/hr/outside/base/pinyin'  // 拼音验证接口
export const API_GET_SCHEDULE = '/eim-hr-hrcore/api/hr/hrcore/base/schedule' // 查询工作日日历
export const API_GET_ADDRESS = '/eim-hr-outside/api/hr/outside/base/work-location' // 获取工作地点接口
export const API_POST_APPLY = '/eim-hr-outside/api/hr/outside/labour/start' // 提交接口
export const API_SAVE_APPLY = '/eim-hr-outside/api/hr/outside/labour' // 保存接口
export const API_GET_LISTLABOUR = '/eim-hr-outside/api/hr/outside/labour/list-labour' // 查询接口
export const API_GET_APPROVE = '/eim-hr-outside/api/hr/outside/labour/appr-history' // 审批历史
export const API_POST_CANCEL = '/eim-hr-outside/api/hr/outside/labour/cancel' // 取消接口
export const API_GET_DOWNFILE = 'eim-hr-outside/api/hr/outside/labour/export-labour' // 导出exle接口
export const API_GET_DETAILAPPLY = '/eim-hr-outside/api/hr/outside/labour/appr-detail' // 获取详情接口
export const API_GET_DETAILURL = '/eim-hr-outside/api/hr/outside/labour/url' // 获取详情url
export const API_GET_DEPTS = '/eim-hr-hrcore/api/hr/hrcore/base/depts' // 获取详情url
export const API_POST_CONFIRM = '/eim-hr-outside/api/hr/outside/labour/confirmJoinedStaff' // 确认入职接口
export const API_GET_COMPANY ='/eim-hr-outside/api/hr/outside/labour/company'//获取公司主体下拉列表
export const API_GET_LABOUR_PHONE ='/eim-hr-outside/api/hr/outside/labour/phone'//获取解密手机号
export const API_GET_SOCIAL = '/eim-hr-hrcore/api/hr/hrcore/induction/salary-info'//获取社保公积金信息
export const API_GET_BGCHECK = '/eim-hr-outside/api/hr/outside/labour/bgcheck-template' // 背调模板
// export const API_UPLOAD_ATTACH = '/zuul/eim-hr-hrcore/api/hr/hrcore/file/encrypt-file' // 附件上传
export const API_DOWNLOAD_ATTACH = '/eim-hr-outside/api/hr/outside/file/download' // 附件下载
export const API_UPLOAD_ATTACH = '/zuul/eim-hr-hrcore/api/hr/hrcore/file/upload' // 附件上传
// export const API_DOWNLOAD_ATTACH = '/eim-hr-hrcore/api/hr/hrcore/file/download' // 附件下载
export const API_MODIFY_INFO = '/eim-hr-outside/api/hr/outside/labour/update-info' // 修改个人信息
export const API_GET_COMPANY_INFO ='/eim-hr-outside/api/hr/outside/labour/company-list'//获取公司主体下拉列表
export const API_GET_EMP_TYPE ='/eim-hr-outside/api/hr/outside/base/empl-type'//获取员工类别下拉列表
export const API_GET_DICTIONARY ='/eim-hr-hrcore/api/hr/hrcore/base/dictionary'//获取渠道字典表
export const API_GET_CHECK_JOBTERLIT ='/eim-hr-outside/api/hr/outside/base/check-jobTerLit'//身份证件号码提示
export const API_GET_LANGUAGE ='/eim-hr-outside/api/hr/outside/base/language'// 外部用工查询语言

export function getOutsideJob(params) {
    return platNet.get(API_GET_OUTJOB, { params })
}
export function getAddress(params) {
    return platNet.get(API_GET_ADDRESS, { params })
}
export function getOutsideCheckId(params) {
    return platNet.post(API_POST_CHECKID, params, { postSign:true, timeout: 90000 })
}
export function getPinyin(params) {
    return platNet.get(API_GET_PINYIN, { params })
}
export function getSchedule(date) {
    return platNet.get(API_GET_SCHEDULE + '/' + date)
}
export function applySubmit(params) {
    return platNet.post(API_POST_APPLY, params , { postSign:true })
}
export function applySave(params) {
    return platNet.post(API_SAVE_APPLY, params , { postSign:true })
}

export function getListLabOur(params) {
    return platNet.get(API_GET_LISTLABOUR, { params })
}

export function getApprove(params) {
    return platNet.get(API_GET_APPROVE, { params })
}

export function getDownFile(params) {
    return platNet.get(API_GET_DOWNFILE, { params, responseType: 'blob', timeout: 90000 })
}

export function cancalInfo(params) {
    return platNet.post(API_POST_CANCEL, params ,{ postSign:true })
}

export function getDetailApply(params) {
    return platNet.get(API_GET_DETAILAPPLY, { params })
}

export function getDetailUrl(params) {
    return platNet.get(API_GET_DETAILURL, { params })
}

export function confirmInfo(params) {
    return platNet.post(API_POST_CONFIRM, params ,{ postSign:true })
}

export function getCompanyList() {
    return platNet.get(API_GET_COMPANY)
}

// 合同主体
export function getCompanyInfo(params) {
    return platNet.get(API_GET_COMPANY_INFO, { params })
}

// 员工类别
export function getEmpType(params) {
    return platNet.get(API_GET_EMP_TYPE, { params })
}

// 查看完整手机号
export function getLabourPhone(params) {
    return platNet.get(API_GET_LABOUR_PHONE, { params })
}

export function getSocialInfo(params) {
    return platNet.get(API_GET_SOCIAL, { params })
}

export function getBgCheck() {
    return platNet.get(API_GET_BGCHECK)
}

export const attachUrl = `${platConfig.baseURL}${API_UPLOAD_ATTACH}`

export function modifyInfo(params) {
    return platNet.post(API_MODIFY_INFO, params , { postSign:true })
}

export function downloadByUrl(url) {
    return platNet.get(url, { responseType: 'blob', timeout: 90000 })
}

export function downloadAttach(params) {
    return platNet.get(API_DOWNLOAD_ATTACH, { params })
}

export function getDictionary(params) {
    return platNet.get(API_GET_DICTIONARY, { params })
}

export function getCheckJobTerLit(params) {
    return platNet.get(API_GET_CHECK_JOBTERLIT, { params })
}

export function getLanguage(params) {
    return platNet.get(API_GET_LANGUAGE, { params })
}

// export function downloadAttach(params) {
//     return platNet.post(API_DOWNLOAD_ATTACH, params)
// }

export function uploadAttachment(params) {
    return platNet.post(
        API_UPLOAD_ATTACH,
        params, {
            timeout: 300000,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        }
    )
}